import SimpleBar from 'simplebar';
import webkitLineClamp from "webkit-line-clamp";

(function ($) {
        jQuery.fn.overlayNavbar = function (options) {
            var $this = this;
            var defaults = {
                //replace {catId} with real id
                url: '/category/{catId}.json',
                externalUrl: 'http://nwd-shop.avency.dev/category/{catId}.json',
                liTemplate: function (cat) {
                    let listItem = '';
                    if (cat.hasChildren) {
                        listItem += '<li class="list-item category-overlay-item" data-cat-is-external="' + cat.isExternal + '" data-cat-id="' + cat.identifier + '" data-cat-toggle="intern" data-cat-url="' + cat.url + '" data-cat-title="' + cat.title + '">' +
                            '<span>' + cat.title + '</span><i class="ai ai-chevron-right pull-right"></i>' +
                            '</li>';
                    } else {
                        listItem = '<a href="' + cat.url + '" class="list-item">' + cat.title + '</a>';
                    }
                    return listItem
                },
                listClass: 'navigation-list',
                leftListClass: 'left-list',
                rightListClass: 'right-list',
                backButtonClass: 'nav-back',
                scrollbarOptions: {autoHide: false},
            };

            //get Settings from Data attributes
            var data = $this.data();
            Object.keys(data).forEach(function (key) {
                let newKey = key.replace(/navbar/, '');
                if (newKey !== key) {
                    newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
                    data[newKey] = data[key];
                }
                delete data[key];
            });
            // set Options
            var opts = $.extend({}, defaults, data, options);

            //set Global Variables
            var leftListIdentifier = '.' + opts.leftListClass;
            var rightListIdentifier = '.' + opts.rightListClass;
            var navigationListIdentifier = '.' + opts.listClass;
            var backButtonIdentifier = '.' + opts.backButtonClass;
            var $backButton = $(backButtonIdentifier);
            var $overlay = $('#navigation');
            var $teaserWrapper = $this.find('.nav-teaser-container');

            // get SubCategories for Category
            function getData($parent, callback) {
                let catId = $parent.data('cat-id');
                let catIsExternal = $parent.data('cat-is-external');
                let url = catIsExternal ? opts.externalUrl : opts.url;
                $.ajax({
                    url: url.replace('{catId}', catId),
                    processData: true,
                    dataType: "json",
                    complete: function (response) {
                        let jsonObj = response.responseJSON;
                        callback($parent, jsonObj);
                    }
                });
            }

            // Build Html from JSON data
            function makeHtml($parent, jsonObj) {
                let catId = $parent.data('cat-id');
                let isExternal = $parent.data('cat-is-external');
                let template = '<ul id="' + catId + '" class="list-group col-12 col-lg-6">';
                template += '<a class="list-item fw-bold" href="' + $parent.data('cat-url') + '">' + $parent.data('cat-title') + '</a>';
                if (jsonObj) {
                    $.each(jsonObj.categories, function (index, cat) {
                        cat.isExternal = isExternal;
                        let listItem = opts.liTemplate(cat);
                        template += listItem;
                    });
                }
                template += '</ul>';
                return $(template).addClass(opts.rightListClass).addClass(opts.listClass);
            }

            // Set active class after element is rendered by the Browser
            function makeActive(elem) {
                setTimeout(function () {
                    elem.addClass('active')
                }, 0)
            }

            //Let lists slide
            function toSlide($toLeft, $toRight, slideOpts = {}) {
                // if the slide directtion is backwards
                let backwards = false;
                //which item is the mainItem / important for mobile display
                var $mainItem = $toRight.length > 0 ? $toRight : $toLeft;
                //if left/right list classes should be set
                var leftRightChange = true;
                //$mainItem = $toRight;
                var $scrollItem = $toRight;

                //set vars depending on mode
                switch (slideOpts.mode) {
                    case 'backwardsMainOnly':
                        leftRightChange = false;
                    case 'backwardsMain':
                        $mainItem = $toLeft.length > 0 ? $toLeft : $toRight;
                    case 'backwards':
                        backwards = true;
                        break;
                    case 'skipLeft':
                        $toLeft = $toRight;
                        $scrollItem = $toLeft;
                        $toRight = $('');
                        $mainItem = $toLeft;
                        break;
                }

                //remove active classes of all lists and items
                $this.find(navigationListIdentifier).removeClass('active');
                $toRight.find('.category-overlay-item').removeClass('active');
                //set left and right list classes
                if (leftRightChange) {
                    $toLeft.removeClass(opts.rightListClass).addClass(opts.leftListClass);
                    $toRight.removeClass(opts.leftListClass).addClass(opts.rightListClass);
                }
                //remove main class for mobile display
                $this.find('.main').removeClass('main');
                //add main class
                $mainItem.addClass('main');

                //start animation depending on direction
                if (backwards) {
                    $toRight.addClass('active');
                    makeActive($toLeft)
                } else {
                    $toLeft.addClass('active');
                    makeActive($toRight);
                    //add a scrollbar
                    if ($scrollItem.length > 0) {
                        new SimpleBar($scrollItem[0], opts.scrollbarOptions);
                        preLoad($scrollItem);
                    }
                }
            }

            //toggle visibility classes
            function visible($element, visibility) {
                if (visibility) {
                    $element.removeClass('invisible').addClass('visible');
                } else {
                    $element.removeClass('visible').addClass('invisible');
                }
            }

            //get Teasers for Category
            function getTeaser(catId) {
                let $teaserbox = $this.find('#teaser-box-' + catId);
                let dataUrl = '/?standalone=Avency.Nwd.Base:Content.NavTeaser&catnode=' + catId;
                //if not already loaded > load the teaser
                if ($teaserbox.length === 0) {
                    $.ajax({
                        url: dataUrl,
                        processData: true,
                        dataType: "html",
                        complete: function (response, statusCode) {
                            let teaserBoxes = '';
                            teaserBoxes = '';
                            if (statusCode === 'success' && response.status === 200) {
                                teaserBoxes = response.responseText;
                            }
                            $teaserbox = $(teaserBoxes);
                            $teaserbox.addClass('d-none');
                            $teaserWrapper.append($teaserbox);
                            showTeaserBox($teaserbox)
                        }
                    })
                } else {
                    showTeaserBox($teaserbox)
                }
            }

            //start possible teaser animation / currently none
            function showTeaserBox($teaserbox) {
                $this.find('.teaser-box-wrapper').addClass('d-none');
                $teaserbox.removeClass('d-none');
            }

            // click on Category handler
            $this.on('click navopen', '.category-overlay-item', function (e) {
                e.preventDefault();
                e.stopPropagation();
                let $this = $(this);
                let $parent = $($this.parents(navigationListIdentifier));
                let catId = $this.data('cat-id');
                let $child = $('#' + catId);
                let $grandParent = $('[data-cat-id=' + $parent.attr('id') + ']').parents(navigationListIdentifier);

                if ($parent.length > 0 && e.type !== 'navopen') {
                    visible($backButton, true);
                } else {
                    visible($backButton, false)
                }

                //add/remove Teaser if Possible
                getTeaser(catId);

                //set active classes on click
                $parent.find('.category-overlay-item').removeClass('active');
                $this.addClass('active');

                // set slider Options
                let slideOpts = {};
                slideOpts.mode = 'normal';
                $backButton.removeClass('no-grand-parent');
                if (e.type === 'navopen') {
                    slideOpts.mode = 'skipLeft';
                } else if ($grandParent.length === 0) {
                    $backButton.addClass('no-grand-parent');
                }

                //check if child is already there
                if ($child.length > 0) {
                    toSlide($parent, $child, slideOpts)
                } else {
                    if ($this.data('cat-has-children') !== 0) {
                        getData($this, function ($clickedElement, jsonObj) {
                            let $template = makeHtml($clickedElement, jsonObj);
                            $parent.after($template);
                            toSlide($parent, $template, slideOpts);
                            $template.find('span, a').each(function () {
                                webkitLineClamp(this, 1);
                            });
                        })
                    } else {
                        let $template = $('');
                        toSlide($parent, $template, {mode: 'normal'});
                    }
                }
            });

            function preLoad($parent) {
                $.each($parent.find('.category-overlay-item'), function (key, el) {
                    var $el = $(el);
                    var catId = $el.data('cat-id');
                    var $child = $('#' + catId);
                    if ($child.length === 0 && $el.data('cat-has-children') !== 0) {
                        getData($el, function ($clickedElement, jsonObj) {
                            let $template = makeHtml($clickedElement, jsonObj);
                            $parent.after($template);
                            $template.find('span, a').each(function () {
                                webkitLineClamp(this, 1);
                            });
                        })
                    }
                });
            }

            // trigger the category in Overlay from topbar
            $this.on('click', '.category-nav-item', function () {
                let $this = $(this);
                let $target = $($this.data('cat-target'));

                $target.trigger('navopen');
            });

            //handle the back-buttton click
            $this.on('click', backButtonIdentifier, function (e) {
                e.preventDefault();
                e.stopPropagation();
                let slideMode = 'backwards';
                let $child = $(leftListIdentifier + '.active');
                let $parent = $('[data-cat-id=' + $child.attr('id') + ']').parents(navigationListIdentifier);
                let $rightlist = $(rightListIdentifier + '.active');

                let $grandParent = $('[data-cat-id=' + $parent.attr('id') + ']').parents(navigationListIdentifier);

                getTeaser($child.attr('id'));

                if ($grandParent.length === 0) {
                    $backButton.addClass('no-grand-parent');
                } else {
                    $backButton.removeClass('no-grand-parent');
                }
                if ($parent.length > 0) {
                    visible($backButton, true);
                } else {
                    slideMode = 'backwardsMainOnly';
                    visible($backButton, false)
                }
                if ($rightlist.length === 0) {
                    slideMode = 'backwardsMain';
                }

                toSlide($parent, $child, {mode: slideMode});
            });

            //initialize scrollbars
            $this.find('.my-scroll-bar').each(function () {
                new SimpleBar(this, opts.scrollbarOptions);
            });

            // close overlay on search click
            $this.on('click', '.ai.ai-search', function (e) {
                const searchItem = document.querySelector('.search-item');
                const searchElement = document.querySelector('.search-collapse');
                const searchOpenClass = 'search-open';
                const searchHideClass = 'search-hide';

                const isOpen = searchItem.classList.contains(searchOpenClass);
                searchElement.classList.toggle(searchHideClass, isOpen);
                searchElement.classList.toggle('show', !isOpen);
                searchItem.classList.toggle(searchOpenClass);
            });

            //close overlay on whitespace click
            $('body').on('click', '.navi-close', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('body').removeClass('noscroll');
                $overlay.removeClass('show');
                // $this.find(navigationListIdentifier + ':first-child').removeClass('active main');
                $this.find(navigationListIdentifier).removeClass('active');
            });

            $('body').on('click', '.navbar-expand-btn', function () {
                $('body').addClass('noscroll');
                $overlay.addClass('show');
                $this.find(navigationListIdentifier + ':first-child').addClass('active main');
                $this.find(navigationListIdentifier + ':not(:first-child)').removeClass('active main');
            });

            $this.on('click', '.category-nav-item', function () {
                $('body').addClass('noscroll');
                $overlay.addClass('show');
                $this.find(navigationListIdentifier + ':first-child').removeClass('active main');
            });

            //close overlay on anchor link click on same page
            $this.on('click', '.list-item', function (e) {
                if (e.target) {
                    const href = e.target.href;
                    if (href !== undefined && href.indexOf(window.location.href) > -1 && href.includes('#')) {
                        $overlay.removeClass('show');
                    }
                }
            });

            // Click on menu item without children
            const singleMenuItem = document.querySelectorAll('li.category-overlay-item .single-menu-item');
            if (singleMenuItem.length > 0) {
                singleMenuItem.forEach(function (element) {
                    element.addEventListener('click', function () {
                        const parentElement = this.closest('li.category-overlay-item');
                        const catUrl = parentElement.dataset.catUrl;

                        if (catUrl) {
                            $overlay.removeClass('show');
                            window.location.href = catUrl;
                        }
                    });
                });
            }

            preLoad($this.find(navigationListIdentifier + ':first-child'));
        }
    }
)(jQuery);
